






































import computedStrings from "@/mixins/computedStrings";
import VStringsInputTable from "@/components/inventoryComponents/strings/layout/VStringsInputTable.vue";
import { BarLoader } from "@saeris/vue-spinners";
import VSaveButton from "@/components/UI/buttons/VSaveButton.vue";
import VCloseFormButton from "@/components/UI/buttons/VCloseFormButton.vue";
import { updateStrings } from "@/services/stringInventory";
import { GenericOutcome } from "@/util/commonTypes";
import Component, { mixins } from "vue-class-component";
import { InstrumentString } from "@/util/stringTypes";


@Component({
  props: {
    strings: {
      type: Array,
      required: true
    },
    updateText: {
      type: String,
      required: true
    },
    submitPath: {
      type: String,
      required: true
    }
  },
  components: { VCloseFormButton, VSaveButton, VStringsInputTable, BarLoader },
})
export default class VUpdateStringsForm extends mixins(computedStrings) {
  public strings!: InstrumentString[];
  public updateText!: string;
  public submitPath!: string;

  items: {[id: string]: number} = {};
  loading = false;

  created(): void {
    this.initializeItems();
  }

  initializeItems(): void {
    for (const item of this.strings) {
      if (item.id) {
        this.items[item.id] = 0;
      }
    }
  }

  handleChange({ id, value }: {id: string, value: number}): void {
    this.items[id] = value;
  }

  async handleSubmit(): Promise<void> {
    const updates: { id: string, amount: number }[] = [];
    for (const [id, amount] of Object.entries(this.items)) {
      if (amount !== 0) {
        updates.push({
          id, amount
        });
      }
    }
    this.loading = true;
    const [outcome, updatedIds, updatedItems, message] = await updateStrings(this.submitPath, { string_updates: updates });
    this.loading = false;
    switch (outcome) {
      case GenericOutcome.Ok:
        this.$emit("updated", { updatedIds, updatedItems });
        if (message.length > 0) {
          this.$toasted.error(message);
        }
        this.$emit("close");
        break;
      case GenericOutcome.Err:
        this.$toasted.error(message);
        break;
      default:
        this.$toasted.error("Something went wrong", { duration: 2000 });
    }
  }
}

